import {
  AssessmentOutlined,
  FolderOutlined,
  CloudOutlined,
  QueueOutlined,
  SettingsOutlined,
  Filter
} from '@material-ui/icons/';

import { ReactElement } from 'react';

export type MenuTreeChild = {
  menuId: string;
  name: string;
  urls: string[];
};

export type MenuTreeParent = {
  menuId: string;
  name: string;
  icon: ReactElement;
  childMenu: MenuTreeChild[];
};

// 各メニューの間に新規メニューが追加されても違和感がないようmenuIdを定義
export const DASHBOARD: MenuTreeChild = {
  menuId: 'DASHBOARD',
  name: 'ダッシュボード',
  urls: ['/dashboard']
};

const SALES_SETTING: MenuTreeChild = {
  menuId: 'SALES_SETTING',
  name: '目標設定',
  urls: ['/sales/setting']
};

const CUSTOMERS: MenuTreeChild = {
  menuId: 'CUSTOMERS',
  name: '顧客',
  urls: ['/customers']
};
const VENDORS: MenuTreeChild = {
  menuId: 'VENDORS',
  name: '業者',
  urls: ['/vendors']
};
const CONSTRUCTIONS: MenuTreeChild = {
  menuId: 'CONSTRUCTIONS',
  name: '工事',
  urls: ['/constructions']
};

const DAILY_REPORTS: MenuTreeChild = {
  menuId: 'DAILY_REPORTS',
  name: '日報',
  urls: ['/daily-reports']
};
const PROCESSES: MenuTreeChild = {
  menuId: 'PROCESSES',
  name: '工程',
  urls: ['/processes']
};
const CALENDER: MenuTreeChild = {
  menuId: 'CALENDER',
  name: 'カレンダー',
  urls: ['/calendar']
};
const ATTENDANCE: MenuTreeChild = {
  menuId: 'ATTENDANCE',
  name: '出面管理',
  urls: ['/attendance']
};

const ESTIMATES: MenuTreeChild = {
  menuId: 'ESTIMATES',
  name: '書類',
  urls: [
    '/estimates',
    '/invoices',
    '/merchandise-orders',
    '/outsource-orders',
    '/site-contacts',
    '/working-budgets'
  ]
};

const PDF_DOWNLOAD: MenuTreeChild = {
  menuId: 'PDF_DOWNLOAD',
  name: 'PDFダウンロード',
  urls: ['/pdf']
};

const DOCUMENT_TRANSMISSION: MenuTreeChild = {
  menuId: 'DOCUMENT_TRANSMISSION',
  name: 'メール送信履歴',
  urls: ['/document-transmission']
};

const FILES: MenuTreeChild = {
  menuId: 'FILES',
  name: '資料',
  urls: ['/files']
};
const PICTURES: MenuTreeChild = {
  menuId: 'PICTURES',
  name: '写真',
  urls: ['/pictures']
};
const GUEST_MANAGE: MenuTreeChild = {
  menuId: 'GUEST_MANAGE',
  name: '共有先管理',
  urls: ['/guest-manage']
};
const FILE_LOG: MenuTreeChild = {
  menuId: 'FILE_LOG',
  name: '操作履歴',
  urls: ['/filelog', '/picturelog']
};
const LEDGER_LIST: MenuTreeChild = {
  menuId: 'LEDGER_LIST',
  name: '写真台帳',
  urls: ['/ledger-list']
};

const CUSTOMER_TYPES: MenuTreeChild = {
  menuId: 'CUSTOMER_TYPES',
  name: '顧客種別マスタ',
  urls: ['/customertypes']
};
const PARTNER_CATEGORIES: MenuTreeChild = {
  menuId: 'PARTNER_CATEGORIES',
  name: '業種マスタ',
  urls: ['/partner-categories']
};
const CONSTRUCT_TYPES_MASTER: MenuTreeChild = {
  menuId: 'CONSTRUCT_TYPES_MASTER',
  name: '案件種別マスタ',
  urls: ['/construct-types']
};
const ESTIMATE_MASTER: MenuTreeChild = {
  menuId: 'ESTIMATE_MASTER',
  name: '見積書マスタ',
  urls: ['/estimate-master']
};
const UNIT_MASTER: MenuTreeChild = {
  menuId: 'UNIT_MASTER',
  name: '単位マスタ',
  urls: ['/unit_master']
};
const FILE_TYPES: MenuTreeChild = {
  menuId: 'FILE_TYPES',
  name: '資料種別',
  urls: ['/filetypes']
};
const COMPANY_INFORMATION: MenuTreeChild = {
  menuId: 'COMPANY_INFORMATION',
  name: '自社情報',
  urls: ['/company-information']
};
const EMPLOYEE_MASTER: MenuTreeChild = {
  menuId: 'EMPLOYEE_MASTER',
  name: '社員',
  urls: ['/employee-masters']
};
const EMPLOYEE_GROUPS: MenuTreeChild = {
  menuId: 'EMPLOYEE_GROUPS',
  name: '社員グループ',
  urls: ['/employee-groups']
};

const DASHBOARD_SECTION: MenuTreeParent = {
  menuId: 'DASHBOARD_SECTION',
  name: 'ダッシュボード',
  icon: <AssessmentOutlined style={{ color: 'fff' }} />,
  childMenu: [DASHBOARD, SALES_SETTING]
};

const INFORMATION_MANAGEMENT_SECTION: MenuTreeParent = {
  menuId: 'INFORMATION_MANAGEMENT_SECTION',
  name: '情報管理',
  icon: <FolderOutlined style={{ color: 'fff' }} />,
  childMenu: [CUSTOMERS, VENDORS, CONSTRUCTIONS]
};

const SITE_MANAGEMENT_SECTION: MenuTreeParent = {
  menuId: 'SITE_MANAGEMENT_SECTION',
  name: '現場管理',
  icon: <Filter style={{ color: 'fff' }} />,
  childMenu: [DAILY_REPORTS, PROCESSES, CALENDER, ATTENDANCE]
};

const TOOL_SECTION: MenuTreeParent = {
  menuId: 'TOOL_SECTION',
  name: 'ツール',
  icon: <QueueOutlined style={{ color: 'fff' }} />,
  childMenu: [ESTIMATES, PDF_DOWNLOAD, DOCUMENT_TRANSMISSION]
};

const CLOUD_STORAGE_SECTION: MenuTreeParent = {
  menuId: 'CLOUD_STORAGE_SECTION',
  name: 'クラウドストレージ',
  icon: <CloudOutlined style={{ color: 'fff' }} />,
  childMenu: [FILES, PICTURES, GUEST_MANAGE, FILE_LOG, LEDGER_LIST]
};

const VARIOUS_PREFERENCE_SECTION: MenuTreeParent = {
  menuId: 'VARIOUS_PREFERENCE_SECTION',
  name: '各種設定',
  icon: <SettingsOutlined style={{ color: 'fff' }} />,
  childMenu: [
    CUSTOMER_TYPES,
    CONSTRUCT_TYPES_MASTER,
    PARTNER_CATEGORIES,
    ESTIMATE_MASTER,
    UNIT_MASTER,
    FILE_TYPES,
    COMPANY_INFORMATION,
    EMPLOYEE_MASTER,
    EMPLOYEE_GROUPS
  ]
};

export const MenuTree: MenuTreeParent[] = [
  DASHBOARD_SECTION,
  INFORMATION_MANAGEMENT_SECTION,
  SITE_MANAGEMENT_SECTION,
  TOOL_SECTION,
  CLOUD_STORAGE_SECTION,
  VARIOUS_PREFERENCE_SECTION
];

export const MenuList: MenuTreeChild[] = MenuTree.reduce<MenuTreeChild[]>(
  (result, subList) => {
    const list = subList.childMenu.map(childMenu => childMenu);
    return result.concat(list);
  },
  []
);
